import Tabs from '../util/tabs';

class HorizontalTabs {
  constructor(el) {
    this.el = el;
    this.init = this.init.bind(this);
    this.init();
  }

  init() {
    new Tabs({
      el: this.el,
    });
  }
}

export default HorizontalTabs;
